import type { LC } from '@use-gpu/live';
import type { OffscreenRenderContext } from '@use-gpu/core';
import type { OutlineOptions } from '../../pass/types';

import { use, gather, yeet, memo } from '@use-gpu/live';

//import { useRenderContext } from '../providers/render-provider';
import { RenderTarget } from '../render-target';

export const OUTLINE_EDGE_FORMAT = 'rg8unorm';

export const OutlineBuffer: LC = memo(() => {

  const targets = [
    use(RenderTarget, {
      label: 'Outline/Edges',
      sampler: null,
      samples: 1,
      format: OUTLINE_EDGE_FORMAT,
      depthStencil: null,
      colorSpace: 'linear',
    }),
  ];

  return gather(targets, (targets: OffscreenRenderContext[]) => {
    return yeet({
      targets: { outline: targets },
    });
  });
}, 'OutlineBuffer');

export const DEFAULT_OUTLINE_OPTIONS = {
  inner: 1,
  outer: 2,
  color: [0, 0, 0, 1],
  blend: 'premultiply',

  depthRamp: 50,
  normalRamp: 20,
};

export const parseOutlineOptions = (opt: boolean | number | Partial<OutlineOptions>) => ({
  ...DEFAULT_OUTLINE_OPTIONS,
  ...(
    opt === true ? {} :
    typeof opt === 'number' ? {inner: opt, outer: opt * 2 + 1} :
    opt
  ),
});
